export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('apollo:error', (error: Error) => {
      const authError = error?.graphQLErrors?.find((err) => err.extensions?.category === 'graphql-authorization')
      if (authError) {
        const { reset } = useAccount()
        reset()
      }
  })
})
